module.exports = __webpack_public_path__ + "img/Body_Normal.74bbf12.png";